Auth = require 'db/auth'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
stickerSize = require 'data/sticker-size'

module.exports = class StickerSelectionView extends View
  className: 'sticker-select js-draggable-sticker'

  enabled: ->
    !@model.get('premium') ||
    Auth.me().isFeatureEnabled('additionalStickers') ||
    @options.org?.isFeatureEnabled('additionalStickers')

  render: ->
    data = @model.toJSON()
    data.url =
      Util.smallestPreviewBiggerThan(data.scaled, stickerSize)?.url ? data.url
    data.pending = !data.image? && !data.id? && !data.error?

    @$el
      .toggleClass('disabled', !@enabled())
      .html(
        templates.fill(
          'sticker_select_item'
          data
        )
      )
      .data('sticker', @model) # For draggable

    @



// WEBPACK FOOTER //
// ./app/scripts/views/stickers/sticker-selection-view.coffee